import { Product } from './Product';
import { Vehicle } from './Vehicle';
import { Driver } from './Driver';

export interface Balance {
    value: number;
    liters: number;
}

export class SaleTransaction {
    constructor(
        public vehicle: Vehicle | null,
        public product: Product | null,
        public driver: Driver | null,
        public odometer: string,
        public liters: string,
        public totalValue: string,
        public password: string,
        public balance: Balance | null,
        public basePrice: number | null,
        public authorization?: string,
        public document?: string,
        public clientReceipt?: string,
        public establishmentReceipt?: string,
        public transactionId?: number,
        public xmlAttached: boolean = false
    ) {}

    get pricePerLiter(): number {
        if (!this.liters || !this.totalValue) return 0;
        const litersNum = parseFloat(this.liters.replace(',', '.'));
        const totalNum = parseFloat(this.totalValue.replace(',', '.'));
        if (litersNum <= 0) return 0;
        return totalNum / litersNum;
    }

    get isPriceMatch(): boolean {
        if (!this.basePrice) return false;
        const pricePerLiter = this.pricePerLiter;
        if (pricePerLiter === 0 || this.basePrice === 0) return false;
        return Math.abs(pricePerLiter - this.basePrice) < 0.01;
    }

    get isValid(): boolean {
        return !!(
            this.vehicle &&
            this.product &&
            this.driver?.isIdentified &&
            this.odometer &&
            this.liters &&
            this.totalValue &&
            this.password
        );
    }

    get formattedPricePerLiter(): string {
        return this.pricePerLiter.toFixed(2);
    }

    get formattedBalanceLiters(): string {
        if (!this.balance) return '-';
        return `${this.balance.liters.toFixed(1).replace('.', ',')} L`;
    }

    get formattedBalanceValue(): string {
        if (!this.balance) return '-';
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(this.balance.value);
    }

    static createEmpty(): SaleTransaction {
        return new SaleTransaction(
            null,
            null,
            Driver.createUnidentified(),
            '',
            '',
            '',
            '',
            null,
            null
        );
    }

    resetSaleData(): SaleTransaction {
        return new SaleTransaction(
            this.vehicle,
            null,
            Driver.createUnidentified(),
            '',
            '',
            '',
            '',
            null,
            null
        );
    }

    resetAll(): SaleTransaction {
        return SaleTransaction.createEmpty();
    }
}

